import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nip", "companyName", "address", "spinner", "error"]

  connect() {
    this._timer = null
  }

  lookup(event) {
    const nip = event.target.value.replace(/\D/g, "")
    clearTimeout(this._timer)
    if (nip.length !== 10) return
    this._timer = setTimeout(() => this._fetch(nip), 500)
  }

  async _fetch(nip) {
    this.spinnerTarget.style.display = "block"
    this.errorTarget.textContent = ""
    const r = await fetch(`/clients/nip_lookup?nip=${nip}`)
    this.spinnerTarget.style.display = "none"
    if (r.ok) {
      const d = await r.json()
      if (d.name && this.companyNameTarget.value === "") this.companyNameTarget.value = d.name
      if (d.address && this.addressTarget.value === "") this.addressTarget.value = d.address
    } else {
      const d = await r.json()
      this.errorTarget.textContent = d.error || "Nie znaleziono"
    }
  }
}
